export enum Step {
  JobDetails = 0,
  SkillsEducation = 1,
}

export enum WorkplaceType {
  HYBRID = 'HYBRID',
  REMOTE = 'REMOTE',
  ONSITE = 'ONSITE',
}
